import { render, staticRenderFns } from "./ImportFactoryProducts.vue?vue&type=template&id=23f00c39"
import script from "./ImportFactoryProducts.vue?vue&type=script&lang=js"
export * from "./ImportFactoryProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports